import arSummaryService from './ArSummaryService';

export default arSummaryService;
